"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LocalStorageStore = /** @class */ (function () {
    /**
     *
     *  Manager for the local storage store. Allowing you to easy set,
     *  get and remove stuff from the local storage.
     *
     *  @param prefix The prefix to use for the key
     *
     */
    function LocalStorageStore(prefix) {
        /**
         *  The prefix of the item key, used to prefix every key.
         */
        this._keyPrefix = '';
        this._keyPrefix = prefix;
    }
    /**
     *
     *  Used to set data in the local storage.
     *
     *  @param key The key to use
     *  @param data The data to store
     *
     */
    LocalStorageStore.prototype.set = function (key, data) {
        if (typeof data === 'object') {
            data = JSON.stringify(data);
        }
        if (typeof data !== 'string') {
            throw new Error("LocalStorageStore set \u2192 provided data is not a string or object: ".concat(data));
        }
        localStorage.setItem(this._getKey(key), data);
    };
    /**
     *
     *  Used to get data out of the local storage.
     *
     *  (i) Attempts to parse the value to JSON,
     *  returns the string value if it fails
     *
     *  @param key The key of the data to get
     *
     *  @return The value out of the local storage, parsed to JSON if possible
     *
     */
    LocalStorageStore.prototype.get = function (key) {
        var value = localStorage.getItem(this._getKey(key));
        if (!value || !value.length) {
            return null;
        }
        var result;
        try {
            result = JSON.parse(value);
        }
        catch (_error) {
            result = value;
        }
        return result;
    };
    /**
     *
     *  Used to remove data from the local storage.
     *
     *  @param key The key of the data to remove
     *
     */
    LocalStorageStore.prototype.remove = function (key) {
        localStorage.removeItem(this._getKey(key));
    };
    /**
     *
     *  Used to construct the full key to use.
     *
     *  @param key The key to prefix
     *
     *  @return The full key to use
     *
     */
    LocalStorageStore.prototype._getKey = function (key) {
        return "".concat(this._keyPrefix, ":").concat(key);
    };
    return LocalStorageStore;
}());
exports.default = LocalStorageStore;
//# sourceMappingURL=index.js.map